var videoElement = $('.localVideo');

videoElement.each(function() {
    $(this).magnificPopup({
        type: 'inline',
        callbacks: {
            open: function() {
                this.content[0].getElementsByTagName('video')[0].play();
            },
            close: function() {
                this.content[0].getElementsByTagName('video')[0].pause();
            }
        }
    });
});